import React from 'react'
import AmbassadorForm from '../Components/AmbassadorForm/AmbassadorForm'
import Footer from '../Components/Footer/Footer'
import Header from '../Components/Header/Header'

const AmbassadorPage = () => {
  return (
    <>
    <Header minimal/>
    <AmbassadorForm/>
    <Footer/>
    </>
  )
}

export default AmbassadorPage
